module.exports = __webpack_public_path__ + "img/DSC02320.4293660c.jpg";